<template>
  <div>
    <modal name="registration-seized"
           class="vue-dialog modal-registration-seized"
           height="auto"
           :minWidth="250"
           :maxWidth="500"
           :adaptive="true"
           ref="modal"
           @opened="$emit('open')"
           :clickToClose="false">
      <div class="dialog-content">
        <div class="dialog-c-title"
             v-word:modal.registrationSeized.header></div>
        <div class="dialog-c-text"
             v-word:modal.registrationSeized.text></div>
        <div v-if="wordingsEditable"
             @click.prevent="close"
             class="modal-dialog-close"
             title="Close dialog"></div>
        <div class="links">
          <a :href="!wordingsEditable && $router.resolve({ name: 'login' }).href"
             v-word:modal.registrationSeized.button.toLoginPage>
          </a>
        </div>
      </div>
      <div class="vue-dialog-buttons">
      </div>
    </modal>
  </div>
</template>

<script>
import * as mixins from '../mixins';

export default {
  mixins: [mixins.wordedPage],
  methods: {
    open() {
      this.$modal.show('registration-seized');
    },
    close() {
      this.$modal.hide('registration-seized');
    },
    onWordingReady() {
      setTimeout(() => {
        this.$refs['modal'].updateRenderedHeight();
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/modals/RegistrationSeized.vue